import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=33bb5f0e&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb5f0e",
  null
  
)

export default component.exports